var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import '../games.css';
import { member } from "../../../store/login.store";
import { Storage } from "../../../lib/localstorege.service";
import { ApiService } from "../../../lib/http.service";
import { env } from "../../../definitions/global.vars";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import paths from "../../../app/paths";
import { betSlipVisibleSubject } from "../../../store/betslip.store";
import { initialLeftMenu } from "../../../lib/misc.functions";
import { modalServiceSubject } from "../../../components/modal/modal";
import { vrgameList } from "../../../store/static.pages.store";
var VRGamePlayer = function (_a) {
    var slug = _a.slug, _b = _a.isArchive, isArchive = _b === void 0 ? false : _b;
    var accountId = member.id;
    var userToken = Storage.get('token');
    var queryParams = new URLSearchParams({
        slug: slug,
        userToken: userToken || '',
        accountId: String(accountId || ''),
        isArchive: String(isArchive),
        isTest: window.location.origin.includes('test') || window.location.origin.includes('localhost') ? "true" : "false",
    });
    var widgetUrl = "".concat(window.location.origin, "/assets/vr-game-widget/vr-game-widget.html?").concat(queryParams.toString());
    useEffect(function () {
        if (!window.location.origin.includes('test') && !window.location.origin.includes('localhost')) {
            window.location.href = '/';
        }
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = 'auto';
        };
    }, []);
    return (_jsx("div", { children: _jsx("iframe", { title: 'Game Loader', style: {
                width: '100%',
                height: '100%',
                border: 'none',
                minHeight: 'calc(100dvh - 150px)'
            }, allow: "fullscreen; autoplay", src: widgetUrl }, void 0) }, void 0));
};
var VRGameCard = function (_a) {
    var game = _a.game;
    var navigate = useNavigate();
    var handleNavigate = function () {
        if (!game.is_active)
            return;
        if (game.vendor === 10) {
            navigate("/".concat(paths.ALTENARGAMES, "/"));
            return;
        }
        navigate("/".concat(paths.VRGAMES, "/").concat(game.code));
    };
    var handleInfo = function () {
        modalServiceSubject.next({
            title: 'Nasıl Oynanır?',
            content: game.tutorial,
            confirm: {
                cancel: { label: 'Kapat' }
            },
        });
    };
    return (_jsxs("div", __assign({ className: "game-card" }, { children: [!game.is_active && (_jsx("div", __assign({ className: "ribbon ribbon-coming-soon" }, { children: _jsx("span", { children: "YAKINDA" }, void 0) }), void 0)), _jsx("div", __assign({ className: "game-card-body", onClick: handleNavigate }, { children: _jsx("img", { loading: "lazy", src: "".concat(env.cdn_url, "/media/").concat(game.image), alt: game.name, width: 160, height: 180 }, void 0) }), void 0), _jsxs("div", __assign({ className: "game-card-footer" }, { children: [_jsx("button", __assign({ onClick: handleNavigate, disabled: !game.is_active }, { children: "HEMEN OYNA" }), void 0), _jsx("button", __assign({ onClick: handleInfo }, { children: "Nas\u0131l Oynan\u0131r?" }), void 0)] }), void 0)] }), void 0));
};
export default function VRGames() {
    var _this = this;
    var params = useParams();
    var activeSlug = params.slug;
    var _a = useState([]), gamesList = _a[0], setGamesList = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(''), searchText = _d[0], setSearchText = _d[1];
    useEffect(function () {
        initialLeftMenu(false);
        betSlipVisibleSubject.next(false);
        getGames();
        return function () {
            initialLeftMenu(true);
            betSlipVisibleSubject.next(true);
        };
    }, []);
    var getGames = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, rawGames, filteredGames, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(null);
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, new ApiService().start("post", env.accounting_api + "/games/api/list-game/", {
                            vendor: 6,
                            group_by_category: true,
                        }, true)];
                case 2:
                    res = _a.sent();
                    if (res && res.status) {
                        rawGames = res.data || [];
                        filteredGames = rawGames.filter(function (game) { return game.vendor === 6 || game.vendor === 10; });
                        // if(window.location.origin.includes('test') || window.location.origin.includes('localhost')) {
                        //     filteredGames.push({id: 9999, name: 'Sanal At Yarışı', image: null, vendor: 9999, is_active: true})
                        // }
                        setGamesList(filteredGames);
                        vrgameList.splice(0, vrgameList.length);
                        vrgameList.push.apply(vrgameList, filteredGames);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    setError({
                        message: 'Bir hata oluştu, Lütfen Tekrar Deneyin.'
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSearch = function (e) {
        setSearchText(e.target.value);
    };
    var handleFilter = function (e) {
        var value = e.target.value;
        if (value === 'all') {
            setGamesList(__spreadArray([], vrgameList, true));
        }
        if (value === 'popular') {
            var popularGames = vrgameList.slice(0, 5);
            setGamesList(popularGames);
        }
        if (value === 'new') {
            var manualGames = vrgameList.filter(function (game) { return game.vendor === 9999; });
            var newGames = vrgameList
                .filter(function (game) { return game.vendor !== 9999; })
                .sort(function (a, b) { return new Date(b.create_date).getTime() - new Date(a.create_date).getTime(); })
                .slice(0, 5 - manualGames.length);
            setGamesList(__spreadArray(__spreadArray([], manualGames, true), newGames, true));
        }
    };
    if (activeSlug === null || activeSlug === void 0 ? void 0 : activeSlug.includes('gecmis-oyunlar')) {
        return _jsx(VRGamePlayer, { slug: "virtual-races", isArchive: true }, void 0);
    }
    if (activeSlug) {
        return _jsx(VRGamePlayer, { slug: activeSlug, isArchive: false }, void 0);
    }
    var filteredGamesList = searchText.length > 0
        ? gamesList.filter(function (game) { return game.name.toLowerCase().includes(searchText.toLowerCase()); })
        : gamesList;
    return (_jsxs("div", __assign({ className: "game-list-page px-lg-3" }, { children: [_jsx("div", __assign({ className: "row" }, { children: _jsxs("div", __assign({ className: "col-12 col-md-9 mx-auto" }, { children: [_jsxs("div", __assign({ className: "col-12 mt-sm-3" }, { children: [_jsx("button", __assign({ className: "btn btn-primary p-1 p-md-2", value: "all", onClick: handleFilter }, { children: "T\u00FCm Oyunlar" }), void 0), _jsx("button", __assign({ className: "btn btn-primary p-1 p-md-2", value: "popular", onClick: handleFilter }, { children: "Pop\u00FCler Oyunlar" }), void 0), _jsx("button", __assign({ className: "btn btn-primary p-1 p-md-2", value: "new", onClick: handleFilter }, { children: "Yeni Eklenenler" }), void 0)] }), void 0), _jsx("div", __assign({ className: "col-12 col-lg-6 mt-3" }, { children: _jsx("input", { value: searchText, onChange: handleSearch, type: "text", className: "form-control", placeholder: "Oyun Ara" }, void 0) }), void 0), _jsx("div", __assign({ className: "col-12 mt-3" }, { children: _jsxs("div", __assign({ className: "row row-cols-2 row-cols-md-3 row-cols-lg-5" }, { children: [loading && (_jsx("div", __assign({ className: "text-center py-5 mx-auto" }, { children: _jsxs("div", __assign({ className: "lds-roller", style: { position: 'unset' } }, { children: [_jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0)] }), void 0) }), void 0)), !loading && error && (_jsxs("div", __assign({ className: "text-center py-5 mx-auto" }, { children: [_jsx("div", __assign({ className: "alert alert-danger mb-2", role: "alert" }, { children: _jsx("span", { children: error.message }, void 0) }), void 0), _jsx("button", __assign({ className: "btn btn-primary", onClick: getGames }, { children: "Tekrar Dene" }), void 0)] }), void 0)), !loading && !error && filteredGamesList.map(function (game, index) {
                                        return (_jsx("div", __assign({ className: "col" }, { children: _jsx(VRGameCard, { game: game }, void 0) }), 'vr-game-card-' + index));
                                    })] }), void 0) }), void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: "row" }, { children: _jsxs("div", __assign({ className: "card w-100 my-2 p-3" }, { children: [_jsx("div", __assign({ className: "card-title" }, { children: _jsx("h3", __assign({ className: "float-left" }, { children: "Bilgilendirme" }), void 0) }), void 0), _jsx("div", __assign({ className: "card-body pt-sm-1 w-100" }, { children: _jsxs("div", __assign({ className: "row" }, { children: ["Kar\u015F\u0131l\u0131\u011F\u0131 Nakit Olmayan Oyunlar Milli Piyango \u0130daresi g\u00FCvencesiyle d\u00FCzenlenmektedir.", _jsx("br", {}, void 0), "320 say\u0131l\u0131 Kanun H\u00FCkm\u00FCnde Kararname h\u00FCk\u00FCmleri uyar\u0131nca, \u0130dare taraf\u0131ndan tertiplenen Kar\u015F\u0131l\u0131\u011F\u0131 Nakit Olmayan Oyunlar i\u00E7in taahh\u00FCt edilen ikramiyeler Devlet garantisi alt\u0131ndad\u0131r.", _jsx("br", {}, void 0), _jsx("br", {}, void 0), "Kat\u0131l\u0131m Ko\u015Fullar\u0131", _jsx("br", {}, void 0), _jsx("br", {}, void 0), _jsxs("ul", { children: [_jsx("li", { children: "\u00C7ekili\u015Fe kat\u0131lmak i\u00E7in kart sat\u0131n alman\u0131z gerekmektedir. Kartlar Oley.com \u00FCzerinden sat\u0131\u015Fa \u00E7\u0131kacakt\u0131r. Kart detaylar\u0131na ili\u015Fkin bilgiler Oley.com \u00FCyelik hesaplar\u0131 \u00FCzerinden eri\u015Fime a\u00E7\u0131k olacakt\u0131r." }, void 0), _jsx("li", { children: "On sekiz ya\u015F\u0131ndan k\u00FC\u00E7\u00FCkler Kar\u015F\u0131l\u0131\u011F\u0131 Nakit Olmayan Oyunlara i\u015Ftirak edemezler, i\u015Ftirak etmi\u015F olsalar dahi kazand\u0131klar\u0131 ikramiyeleri verilmez ve bedeli \u0130dareye gelir kaydedilir." }, void 0), _jsx("li", { children: "T\u00FCrkiye\u2019de ikamet eden \u201CYabanc\u0131lara Mahsus Kimlik Numaras\u0131\u201D sahibi yabanc\u0131 uyruklu \u00FCyeler oyunlara kat\u0131labilir." }, void 0), _jsx("li", { children: "\u00C7ekili\u015F b\u00FClteninde yer alan t\u00FCm oyunlar i\u00E7in \u00F6nceden kart sat\u0131n al\u0131nabilir." }, void 0), _jsx("li", { children: " Sat\u0131lan biletlerin iadesi yoktur. Ancak, Sat\u0131\u015F\u0131n kapan\u0131p \u00E7ekili\u015Fin ba\u015Flamas\u0131ndan \u00F6nce ilgili odada yeterince i\u015Ftirak\u00E7i yoksa veya yeterli say\u0131da kart sat\u0131lamam\u0131\u015Fsa odan\u0131n \u00E7ekili\u015Fi iptal edilerek, sat\u0131lan kart bedelleri i\u015Ftirak\u00E7ilere sat\u0131n ald\u0131klar\u0131 birim (Oley Puan) olarak iade edilir." }, void 0), _jsx("li", { children: "Talihliler, ikramiyeye konu olan Oley Puan i\u00E7in t\u00FCm vergi ve di\u011Fer yasal \u00FCcretlerden Veraset ve \u0130ntikal Vergisi\u2019nden muaf tutulacakt\u0131r." }, void 0), _jsx("li", { children: "\u0130kramiyelerin kar\u015F\u0131l\u0131\u011F\u0131 paraya tahvil edilemez, bedeli talihlilere nakden veya hesaben \u00F6denemez." }, void 0), _jsx("li", { children: "Bu \u00E7ekili\u015Fe kat\u0131l\u0131m g\u00F6steren t\u00FCm \u00FCyeler \u00C7ekili\u015F Ko\u015Fullar\u0131n\u0131 kabul etmi\u015F say\u0131l\u0131r." }, void 0), _jsx("li", { children: "Talihliler, ikramiyeye konu olan e\u015Fya, hizmet ve/veya puanlar i\u00E7in Veraset ve \u0130ntikal Vergisi\u2019nden muaf tutulacakt\u0131r." }, void 0)] }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0)] }), void 0));
}
